import NotFound from "../pages/NotFoundPage"
import Home from "../pages/Home.vue"
import {FOREIGNER} from "@/constants/constants"

const user = [
    {
        path: "/",
        component: Home,
        name: "home",
    },
    {
        path: "/landing",
        component: () => import("../pages/Landing.vue"),
        name: "landing",
        meta: {
            header: "hidden",
            footer: "hidden",
            virtual_balance_bubble: "hidden",
            robots: "noindex, follow"
        },
    },
    {
        path: "/landing-wa",
        component: () => import("../pages/LandingWa.vue"),
        name: "landingWa",
        meta: {
            header: "hidden",
            footer: "hidden",
            virtual_balance_bubble: "hidden",
            robots: "noindex, follow"
        },
    },
    {
        path: "/register",
        component: () => import("../pages/auth/Register.vue"),
        name: "register",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/login",
        component: () => import("../pages/auth/Login.vue"),
        name: "login",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/login-admin",
        component: () => import("../pages/admin/LoginAdmin.vue"),
        name: "loginAdmin",
        meta: {
            robots: "noindex, nofollow"
        },
    },
    {
        path: "/forgot-password",
        component: () => import("../pages/auth/PasswordForgot.vue"),
        name: "forgotPassword",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/reset-password",
        component: () => import("../pages/auth/PasswordReset.vue"),
        name: "resetPassword",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/verify-email",
        component: () => import("../pages/auth/VerifyEmail.vue"),
        name: "verifyEmail",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/marketplace",
        component: () => import("../pages/property/Marketplace.vue"),
        name: "marketplace",
    },
    {
        path: "/golearn",
        name: "goLearn",
        component: () => import("../pages/golearn/Playlist.vue"),
        meta: {
            footer: 'hidden',
        },
        children: [
            {
                path: "",
                component: () => import("../pages/golearn/Playlist.vue"),
                name: "goLearnMain",
            },
            {
                path: ":slug",
                component: () => import("../pages/golearn/Playlist.vue"),
                name: "goLearnPlaylist",
            },
            {
                path: "video/:uuid",
                component: () => import("../pages/golearn/Playlist.vue"),
                name: "goLearnVideo",
            },
        ]
    },
    {
        path: "/events",
        component: () => import("../pages/event/Events.vue"),
        name: "events",
    },
    {
        path: "/event/:uuid",
        component: () => import("../pages/event/EventDetail.vue"),
        name: "eventDetail",
    },
    {
        path: "/about-us",
        component: () => import("../pages/AboutUs.vue"),
        name: "aboutUs",
    },
    {
        path: "/property/:uuid",
        component: () => import("../pages/property/PropertyDetail.vue"),
        name: "propertyDetail",
    },
    {
        path: "/property-image/:id",
        component: () => import("../pages/property/PropertyImage.vue"),
        name: "propertyImage",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/privacy-policy",
        component: () => import("../pages/PrivacyPolicy.vue"),
        name: "privacyPolicy",
    },
    {
        path: "/terms-of-service",
        component: () => import("../pages/TermsAndConditions.vue"),
        name: "termsAndConditions",
    },
    {
        path: "/buy-success",
        component: () => import("../pages/BuySuccess.vue"),
        name: "buySuccess",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/get-browser-session-id",
        component: () => import("../pages/BrowserSessionId.vue"),
        name: "browserSessionId",
        meta: {
            robots: "noindex, nofollow"
        },
    },
    {
        path: "/order-detail",
        component: () => import("../pages/account/OrderDetail.vue"),
        name: "publicOrderDetail",
        meta: {
            robots: "noindex, follow"
        },
    },
    {
        path: "/ipay88-redirect",
        name: "IPay88Redirect",
        component: () => import("../pages/account/IPay88Redirect.vue"),
        props: route => ({
          checkoutId: route.query.checkoutId,
          signature: route.query.signature
        })
    },
    { path: "/:pathMatch(.*)*", component: NotFound },
]

function createNewRoute (route, routePathPrefix, routeNameSuffix) {
    const newRoute = { ...route };
    // Only prefix if not NotFound
    if (newRoute.path && newRoute.path !== "/:pathMatch(.*)*") {
        newRoute.path = `${routePathPrefix}${newRoute.path}`;
    }
    if (newRoute.name) {
        newRoute.name = `${newRoute.name}${routeNameSuffix}`;
    }
    if (newRoute.children) {
        // For children, don't prefix the path again (they are nested under parent)
        newRoute.children = newRoute.children.map(child =>
            createNewRoute(child, "", routeNameSuffix)
        );
    }
    return newRoute;
}

const userForeigner = user.map(route =>
    createNewRoute(route, FOREIGNER.ROUTE_PATH_PREFIX, FOREIGNER.ROUTE_NAME_SUFFIX)
);

export {user, userForeigner}
